import styled from 'styled-components/macro';
import * as colors from '../common/colorConstants';
import { mediumHeightScreens, mediumScreens, smallScreens } from '../common/fontElements';
import CustomSpinner from '../common/CustomSpinner/CustomSpinner';
import { NextButton } from '../common/buttonsComponents';

export const HeaderContainer = styled.div`
  padding: 30px 30px 20px;
  border-bottom: 1px solid ${colors.lightGray15};
  @media (max-height: ${smallScreens}) {
    padding: 20px 30px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    padding: 10px 30px 15px;
  }
`;

export const TopContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  height: 100%;
  overflow-y: scroll;
`;

export const Spinner = styled(CustomSpinner)`
  width: auto;
`;

export const SpinnerWrapper = styled.div`
  position: relative;
  padding: 150px 0;
  width: 100%;
`;

export const SubTitle = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  color: ${colors.darkGray1};
  margin: 0;
  @media (max-height: ${smallScreens}) {
    font-size: 12px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    font-size: 11px;
  }
`;

export const Title = styled.p`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: ${colors.black4};
  text-align: center;
  margin: 0;
  @media (max-height: ${smallScreens}) {
    font-size: 12px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    font-size: 14px;
  }
`;

export const MacroButton = styled(NextButton)`
  margin: 15px 0px;
  float: none;
`;

export const NoMatchText = styled.p`
  margin-top: ${(props) => (props.marginTop ? props.marginTop : '5px')};
  margin-bottom: 0px;
  font-size: 11px;
  max-width: 430px;
  white-space: pre-wrap;
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${mediumScreens}) {
    font-size: 10px;
  }
`;

export const Wrapper = styled.section`
  display: flex;
  flex-flow: column nowrap;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const ActionsButtonsWrapper = styled.div`
  padding: 18px 30px;
  z-index: 100;
  bottom: 0;
  position: sticky;
  width: 100%;
  min-height: 65px;
  background-color: ${colors.baseBackground};
  box-shadow: 0px -4px 15px rgba(23, 45, 70, 0.08);
`;
